import { useCallback, useMemo, Fragment } from 'react';
import { useSwipeable } from 'react-swipeable';
import Date from './Date';
import { CALC_DIR, setMonthDateArr, setCalcMonthDateObj } from './core';
import { useAppDispatch, useAppSelector } from '@hooks/defineRtkTypedHook';
import { setDrawDate, selectedDrawDate } from '@features/calendar/CalendarSlice';
import type { IDateObj, IDataByDateMap } from '@type/index';

interface IMonthProps {
  dataByDateMap: IDataByDateMap;
  isShowCalendarMark: boolean;
}

const Month = ({ dataByDateMap, isShowCalendarMark }: IMonthProps) => {
  const dispatch = useAppDispatch();
  const drawDate = useAppSelector(selectedDrawDate);
  const month = useMemo(() => drawDate?.month, [drawDate]);
  const monthDateArr = useMemo(() => setMonthDateArr(drawDate), [month]);

  const swipeCallback = useCallback((date: IDateObj) => {
    dispatch(setDrawDate(date));
  }, []);

  const goPrevMonth = useCallback(() => {
    const prevDate = setCalcMonthDateObj(drawDate, CALC_DIR.MINUS);
    swipeCallback(prevDate);
  }, [drawDate]);

  const goNextMonth = useCallback(() => {
    const nextDate = setCalcMonthDateObj(drawDate, CALC_DIR.PLUS);
    swipeCallback(nextDate);
  }, [drawDate]);

  const swipeHandlers = useSwipeable({
    onSwipedLeft: goNextMonth,
    onSwipedRight: goPrevMonth,
  });

  return (
    <div className="month calendar-month" {...swipeHandlers}>
      {Array.isArray(monthDateArr) && monthDateArr?.length > 0 ? (
        monthDateArr?.map((weekDateArr, i) => (
          <div key={`week-${i}`} className="week">
            {weekDateArr?.map((date, j) => {
              const { year, month } = drawDate || {};
              const hasData =
                !!date &&
                dataByDateMap &&
                Array.isArray(dataByDateMap[year]) &&
                dataByDateMap[year][month - 1][date - 1]?.length > 0;
              const hasMark = isShowCalendarMark && hasData;

              return <Date key={`${date}-${j}`} dateObj={{ ...drawDate, date, day: j }} hasMark={hasMark} />;
            })}
          </div>
        ))
      ) : (
        <Fragment />
      )}
    </div>
  );
};

export default Month;
